<script>
import {useProductStore} from "@js/store/ProductStore.js";

export default {
  name: "ProductTitle",
  setup() {
    const productStore = useProductStore()

    return {productStore}
  }
}
</script>

<template>
  <div>
    <h1 class="flex items-center text-2xl md:text-3xl font-bold mb-0">
      {{ productStore.product.title }}
    </h1>
    <div class="flex mt-2">
      <!--            <div :class="[productStore.product.availability ? 'bg-emerald-700' : 'bg-red-600' ]"-->
      <!--                 class="ms-0 md:ms-5 font-bold text-[12px] text-white px-3 py-1 rounded leading-5">-->
      <!--                {{ productStore.product.availability ? 'В наличии' : 'Нет в наличии' }}-->
      <!--            </div>-->
      <div v-if="productStore.product.bestseller"
           class="font-bold text-[12px] text-white px-3 py-1 rounded bg-[#c52314] leading-5">
        ХИТ Продаж
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
